/** 个人资料：昵称最大字数（与 H5、服务端一致） */
export const USER_PROFILE_NICKNAME_MAX_LENGTH = 8;
